module.exports = {"411521001":"丽水街道","411521002":"宝城街道","411521003":"龙山街道","411521101":"周党镇","411521102":"竹竿镇","411521103":"灵山镇","411521104":"子路镇","411521105":"楠杆镇","411521106":"青山镇","411521107":"潘新镇","411521108":"彭新镇","411521109":"莽张镇","411521110":"东卜镇","411521111":"铁铺镇","411521202":"庙仙乡","411521204":"定远乡","411521205":"山店乡","411521207":"朱堂乡","411521208":"尤店乡","411521209":"高店乡","411521400":"河南省五一农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411521.json
// module id = 1666
// module chunks = 0